function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.265 1.807L5.412 3.446C4.01818 4.42177 2.97176 5.8165 2.42474 7.4276C1.87772 9.03869 1.8586 10.7822 2.37015 12.4049C2.88171 14.0276 3.89729 15.445 5.26937 16.4511C6.64146 17.4572 8.29858 17.9996 10 17.9996C11.7014 17.9996 13.3585 17.4572 14.7306 16.4511C16.1027 15.445 17.1183 14.0276 17.6299 12.4049C18.1414 10.7822 18.1223 9.03869 17.5753 7.4276C17.0282 5.8165 15.9818 4.42177 14.588 3.446L15.735 1.807C17.053 2.72843 18.1289 3.95446 18.8715 5.38087C19.614 6.80728 20.0012 8.39189 20 10C20 15.523 15.523 20 10 20C4.477 20 2.59023e-06 15.523 2.59023e-06 10C-0.00115543 8.39189 0.385992 6.80728 1.12853 5.38087C1.87107 3.95446 2.94705 2.72843 4.265 1.807ZM9 10V0H11V10H9Z"
});

var SvgShutdown = function SvgShutdown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShutdown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shutdown.098b9a8c.svg";
export { ForwardRef as ReactComponent };